import {ThemeIconKey} from 'platform/foundation';
import {match} from 'ts-pattern';

const FILE_ICON_CSV = 'files_default/file_type_CSV';
const FILE_ICON_XLS = 'files_default/file_type_XLS';
const FILE_ICON_FALLBACK = 'files_compact/property_XLS_CSV';

export function getFileIconKey(fileName: string): ThemeIconKey {
  const lower = fileName.toLowerCase();
  return match<string, ThemeIconKey>(lower)
    .when(
      (name) => name.endsWith('.csv'),
      () => FILE_ICON_CSV
    )
    .when(
      (name) => name.endsWith('.xls') || name.endsWith('.xlsx'),
      () => FILE_ICON_XLS
    )
    .otherwise(() => FILE_ICON_FALLBACK);
}
